import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import AboutMe from "./components/Home/AboutMe/AboutMe";
import Blogs from "./components/Home/Blogs/Blogs";
import Contact from "./components/Home/Contact/Contact";
import Home from "./components/Home/Home/Home";
import NotFound from "./components/Home/NotFound/NotFound";
import Portfolio from "./components/Home/Portfolio/Portfolio";
import Resume from "./components/Home/Resume/Resume";

const App = () => {
  return (
    <div>
      <Router>
        <Switch>
          <Route exact path="/">
            <Home></Home>
          </Route>
          <Route path="/home">
            <Home></Home>
          </Route>
          <Route path="/aboutMe">
            <AboutMe></AboutMe>
          </Route>
          <Route path="/Resume">
            <Resume></Resume>
          </Route>
          <Route path="/portfolio">
            <Portfolio></Portfolio>
          </Route>
          <Route path="/blog">
            <Blogs></Blogs>
          </Route>
          <Route path="/contact">
            <Contact></Contact>
          </Route>
          <Route path="*">
            <NotFound></NotFound>
          </Route>
        </Switch>
      </Router>
    </div>
  );
};

export default App;
